import { useRecoilValue } from "recoil";
import { companiesAtom } from "../miscellaneous/companiesAtom";

export const useCompaniesValue = () => {
  const companiesValue = useRecoilValue(companiesAtom);

  return companiesValue;
};
